import React, { Fragment } from 'react';
import styled from 'styled-components';

import AmenityIcon from './assets/AmenityIcon.svg';
import AmenityCancelledIcon from './assets/AmenityCancelledIcon.svg';

import ExpandableActivityCard from './ExpandableActivityCard';
import Divider from 'components/ui/Divider';

import { getTranslatedString } from 'helpers/i18n';
import { colors } from 'helpers/ColorHelper';

const StyledDivider = styled(Divider)`
  margin-top: 15px;
  margin-bottom: 15px;
  height: 2px;
  background-color: rgba(0, 0, 0, 0.06);
`;

const StyledSubtitle = styled.p`
  font-size: 14px;
  margin: 0;
  color: ${colors.CHAR_COUNT};
`;

const StyledDateString = styled.p`
  font-weight: 500;
  font-size: 16px;
  margin: 0;
  color: ${colors.MED_DARK_GRAY};
`;

const StyledNoteText = styled.p`
  font-size: 16px;
  margin: 0;
  color: ${colors.MED_DARK_GRAY};
`;

const AmenityCard = ({
  isCancelled = false,
  title,
  propertyName,
  modifiedDate,
  bookingDate,
  internalNotes,
}) => {
  const bodyContent = (
    <Fragment>
      <StyledDivider />
      <StyledSubtitle>
        {getTranslatedString('landlordPortal.tenantDetails.activity.booking')}
      </StyledSubtitle>
      <StyledDateString>{bookingDate}</StyledDateString>
    </Fragment>
  );

  const hiddenContent = internalNotes && (
    <Fragment>
      <StyledDivider />
      <StyledSubtitle>
        {getTranslatedString('landlordPortal.tenantDetails.activity.internalNotes')}
      </StyledSubtitle>
      <StyledNoteText>{internalNotes}</StyledNoteText>
    </Fragment>
  );

  return (
    <ExpandableActivityCard
      icon={isCancelled ? AmenityCancelledIcon : AmenityIcon}
      title={`${title} ${isCancelled
        ? getTranslatedString('landlordPortal.tenantDetails.activity.cancelled')
        : ''}`}
      propertyName={propertyName}
      dateString={getTranslatedString('landlordPortal.tenantDetails.activity.lastModifiedOn', {
        modifiedDate: modifiedDate,
      })}
      bodyContent={bodyContent}
      hiddenContent={hiddenContent}
    />
  );
};

export default AmenityCard;
